import sha512 from 'crypto-js/sha512';

export class HtmlToPdf
{
	pdfButtons = document.querySelectorAll('[data-s~="HtmlToPdf"]');
	printButtons = document.querySelectorAll('[data-s~="HtmlToPrinter"]');
    tempFormId = 'temp-html-to-pdf-or-printer-form';

	constructor(store)
	{
        this.store = store;
	}

    getHtmlSelector()
    {
        this.htmlSelector = (this.method === 'printer') ? this.currentButton.dataset.htmltoprinterSelector : this.currentButton.dataset.htmltopdfSelector;
    }

    getHtml()
    {
        this.html = document.querySelector(this.htmlSelector);
    }

    sendDataToBackend()
    {
        const prevTempForm = document.querySelector('#' + this.tempFormId);
        if (prevTempForm) {
            prevTempForm.remove();
        }

        const tempForm = document.createElement('form');
        tempForm.setAttribute('method', 'post');
        tempForm.setAttribute('action', (this.method === 'printer') ? '/drukuj' : '/pdf');
        tempForm.setAttribute('id', this.tempFormId);
        tempForm.setAttribute('target', '_blank');
        tempForm.setAttribute('rel', 'noopener noreferrer nofollow');
        tempForm.style.display = 'none';

        const contentField = document.createElement('textarea');
        contentField.setAttribute('name', 'content');
        contentField.innerText = btoa(unescape(encodeURIComponent(this.html.innerHTML)));

        const checksumField = document.createElement('input');
        checksumField.setAttribute('type', 'text');
        checksumField.setAttribute('name', 'checksum');
        checksumField.setAttribute('value', sha512(this.html.innerHTML));

        tempForm.append(contentField);
        tempForm.append(checksumField);
        document.body.append(tempForm);
        tempForm.submit();
    }

	watch()
	{
        this.pdfButtons.forEach(e => {
            e.addEventListener("click", () => {
                this.currentButton = e;
                this.method = 'pdf';
                this.getHtmlSelector();
                this.getHtml();
				this.sendDataToBackend();
			});
		});

        this.printButtons.forEach(e => {
            e.addEventListener("click", () => {
                this.currentButton = e;
                this.method = 'printer';
                this.getHtmlSelector();
                this.getHtml();
				this.sendDataToBackend();
			});
		});
	}
}
